import { matchPath } from "react-router-dom";
import { toFirstInstallOnboardingProduct } from "../welcome/welcome-flow";

export function isWelcomeIndexPath(pathname: string): boolean {
  return !!(
    matchPath("/stores/:storeId/welcome", pathname) ||
    matchPath("/welcome", pathname)
  );
}

// The whole welcome subtree (index + per-product children), for suppressing
// global chrome that would stack under the welcome onboarding modal.
export function isWelcomeRoute(pathname: string): boolean {
  return (
    isWelcomeIndexPath(pathname) ||
    !!matchPath("/stores/:storeId/welcome/*", pathname) ||
    !!matchPath("/welcome/*", pathname)
  );
}

export function getFirstInstallRedirectPath(args: {
  required: boolean;
  isRedoAdmin: boolean;
  pathname: string;
  teamId: string;
}): string | null {
  if (!args.required || args.isRedoAdmin) {
    return null;
  }
  if (isWelcomeIndexPath(args.pathname)) {
    return null;
  }
  const welcomeBase = `/stores/${args.teamId}/welcome`;
  const childMatch =
    matchPath("/stores/:storeId/welcome/:slug", args.pathname) ??
    matchPath("/welcome/:slug", args.pathname);
  const product = toFirstInstallOnboardingProduct(childMatch?.params.slug);
  if (product) {
    return `${welcomeBase}?product=${product}`;
  }
  return welcomeBase;
}
